// extracted by mini-css-extract-plugin
export var displayOptionsAsGrid = "CheckBoxField-module__displayOptionsAsGrid___5IHGN";
export var displayOptionsAsRow = "CheckBoxField-module__displayOptionsAsRow___fTGwh";
export var option = "CheckBoxField-module__option___rY++z";
export var optionMargin = "CheckBoxField-module__optionMargin___UpUvL";
export var subtitle = "CheckBoxField-module__subtitle___HPOuM";